import React, { useEffect } from "react";
import { observer } from "mobx-react";
import { callsStore } from "Stores/Calls";

const OPTIONS = [
  ["ALL_MEMBERS", "All team members (Default)", "Everyone can see all calls made by the team."],
  [
    "ADMIN_ONLY",
    "Only admin",
    "Admins see all calls. Team members see only their own calls on the Calls page and in Reports."
  ]
];

const CallLogs = observer(() => {
  useEffect(() => {
    callsStore.loadCallLogAccess();
  }, []);

  return (
    <div className="pdSettings">
      <div className="pdCard">
        <h3>Who can access all call logs</h3>
        <div className="pdDesc">Choose who can see every team member's calls, recordings and call reports.</div>
        <div className="pdRadios callLogAccessRadios" role="radiogroup" aria-label="Who can access all call logs">
          {OPTIONS.map(([value, label, desc]) => (
            <label key={value}>
              <input
                type="radio"
                name="callLogAccess"
                checked={callsStore.callLogAccess === value}
                disabled={!callsStore.callLogAccessLoaded}
                onChange={() => callsStore.saveCallLogAccess(value)}
              />
              <span>
                {label}
                <span className="pdDesc">{desc}</span>
              </span>
            </label>
          ))}
        </div>
      </div>
    </div>
  );
});

export default CallLogs;
